import { useEffect } from "react";
import { ProjetoDimensionadoOffGrid } from "src/components/projetos/dimensionados_offgrid";
import { EdicaoLayoutOffGrid } from "src/components/projetos/edicao/layouts/EdicaoLayoutOffGrid";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Edição projeto dimensionado offgrid";

export const ProjetoDimensionadoOffGridEdicaoPage = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <EdicaoLayoutOffGrid>
      <div className="container">
        <div className="row">
          <div className="X12">
            <ProjetoDimensionadoOffGrid />
          </div>
        </div>
      </div>
    </EdicaoLayoutOffGrid>
  );
};
